"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TEXT_MASKING_CHAR = exports.FORM_PRIVATE_TAG_NAMES = exports.CENSORED_IMG_MARK = exports.CENSORED_STRING_MARK = exports.PRIVACY_CLASS_PREFIX = exports.PRIVACY_ATTR_VALUE_HIDDEN = exports.PRIVACY_ATTR_VALUE_MASK_UNLESS_ALLOWLISTED = exports.PRIVACY_ATTR_VALUE_MASK_USER_INPUT = exports.PRIVACY_ATTR_VALUE_MASK = exports.PRIVACY_ATTR_VALUE_ALLOW = exports.PRIVACY_ATTR_NAME = exports.NodePrivacyLevel = void 0;
exports.getPrivacySelector = getPrivacySelector;
const browser_core_1 = require("@datadog/browser-core");
exports.NodePrivacyLevel = {
    IGNORE: 'ignore',
    HIDDEN: 'hidden',
    ALLOW: browser_core_1.DefaultPrivacyLevel.ALLOW,
    MASK: browser_core_1.DefaultPrivacyLevel.MASK,
    MASK_USER_INPUT: browser_core_1.DefaultPrivacyLevel.MASK_USER_INPUT,
    MASK_UNLESS_ALLOWLISTED: browser_core_1.DefaultPrivacyLevel.MASK_UNLESS_ALLOWLISTED,
};
exports.PRIVACY_ATTR_NAME = 'data-dd-privacy';
// Privacy Attrs
exports.PRIVACY_ATTR_VALUE_ALLOW = 'allow';
exports.PRIVACY_ATTR_VALUE_MASK = 'mask';
exports.PRIVACY_ATTR_VALUE_MASK_USER_INPUT = 'mask-user-input';
exports.PRIVACY_ATTR_VALUE_MASK_UNLESS_ALLOWLISTED = 'mask-unless-allowlisted';
exports.PRIVACY_ATTR_VALUE_HIDDEN = 'hidden';
// Privacy Classes - not all customers can set plain HTML attributes, so support classes too
exports.PRIVACY_CLASS_PREFIX = 'dd-privacy-';
// Private Replacement Templates
exports.CENSORED_STRING_MARK = '***';
exports.CENSORED_IMG_MARK = 'data:image/gif;base64,R0lGODlhAQABAIAAAMLCwgAAACH5BAAAAAAALAAAAAABAAEAAAICRAEAOw==';
exports.FORM_PRIVATE_TAG_NAMES = {
    INPUT: true,
    OUTPUT: true,
    TEXTAREA: true,
    SELECT: true,
    OPTION: true,
    DATALIST: true,
    OPTGROUP: true,
};
exports.TEXT_MASKING_CHAR = 'x';
function getPrivacySelector(privacyLevel) {
    return `[${exports.PRIVACY_ATTR_NAME}="${privacyLevel}"], .${exports.PRIVACY_CLASS_PREFIX}${privacyLevel}`;
}
//# sourceMappingURL=privacyConstants.js.map